<template>
  <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.166992 16.3333V0.5H13.5003L11.8337 4.66667L13.5003 8.83333H1.83366V16.3333H0.166992Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: "FlagIcon"
};
</script>
